// @ts-nocheck

import React, { Fragment, useEffect, useMemo, useRef, useState } from "react";
// import { _base_update, _uploadBaseCover, _uploadBaseLogo, fetchBaseDetails } from './baseAPI';
import { Toaster, toast } from "sonner";
import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
} from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";

import { Dialog, Transition } from "@headlessui/react";
import { useDispatch } from "react-redux";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { RootState } from "../../../app/store";
import {
  baseDetailsData,
  updateBase,
  uploadBaseCover,
  uploadBaseLogo,
} from "../../base/baseSlice";
import { UpdateBasePayload } from "../../base/baseTypes";
import { Menu } from "@headlessui/react";
import { MenuItem, MenuItems, MenuButton } from "@headlessui/react";
import { CustomCheckIcon } from "../../../components/icons";
import { SketchPicker } from "react-color";
import DropDown from "../../../components/common/DropDown";
import SearchableDropdown from "../../../components/common/SearchableDropdown";
import {
  Label,
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/react";
import timezonesData from "../../../utils/timezones.json";

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const timeZoneList = [
  { name: "Pacific/Midway" },
  { name: "Pacific/Honolulu" },
  { name: "Pacific/Marquesas" },
  { name: "America/Anchorage" },
  { name: "America/New_York" },
];

interface BaseDetailsProps {
  userDetails: UserDetails;
}

const colorList = [
  { name: "#69737d" },
  { name: "#c32c68" },
  { name: "#9051b2" },
  { name: "#6a56df" },
  { name: "#2c6cd5" },
  { name: "#318727" },
  { name: "#aa5c00" },
  { name: "#c53c00" },
  { name: "#c53635" },
  { name: "#20808D" },
];

const BaseManage: React.FC<BaseDetailsProps> = React.memo(({ userDetails }) => {
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [color, setColor] = useState("#808080");
  const [data, setData] = useState<any>();
  const [showAlert, setShowAlert] = useState(false);
  const baseInfo = useAppSelector((state: RootState) => state.base.baseDetails);
  const [file, setFile] = useState<File | null>(null);
  const [logoUrl, setLogoUrl] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [cropSrc, setCropSrc] = useState<string | null>(null);
  const [crop, setCrop] = useState<Crop>({
    unit: "px",
    width: 250,
    height: 250,
    x: 0,
    y: 0,
    aspect: 1,
  });
  const [completedCrop, setCompletedCrop] = useState<PixelCrop | null>(null);
  const [showCropModal, setShowCropModal] = useState(false);
  const imageRef = useRef<HTMLImageElement | null>(null);
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const [fileCover, setFileCover] = useState<File | null>(null);
  const [logoUrlCover, setLogoUrlCover] = useState<string>("");
  const [loadingCover, setLoadingCover] = useState<boolean>(false);
  const [cropSrcCover, setCropSrcCover] = useState<string | null>(null);
  const [cropCover, setCropCover] = useState<Crop>({
    unit: "px",
    width: 1200,
    height: 342,
    x: 0,
    y: 0,
    aspect: 7 / 2,
  });
  const [completedCropCover, setCompletedCropCover] =
    useState<PixelCrop | null>(null);
  const [showCropModalCover, setShowCropModalCover] = useState(false);
  const imageRefCover = useRef<HTMLImageElement | null>(null);
  const canvasRefCover = useRef<HTMLCanvasElement | null>(null);
  const [logoLoading, setLogoLoading] = useState(true);
  const [coverLoading, setCoverLoading] = useState(true);
  const [description, setDescription] = useState("");
  const dispatch = useAppDispatch();
  const baseIdString =
    localStorage.getItem("UserBaseId") || localStorage.getItem("createBaseId");
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;
  const [baseLoading, setBaseLoading] = useState(false);
  const [showColorPicker, setShowColorPicker] = useState(false); // State to manage color picker visibility
  const [desEditable, setDesEditable] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [timezone, setTimezone] = useState("GMT");
  useEffect(() => {
    const baseInfoString = localStorage.getItem("baseDetails");
    if (baseInfoString) {
      const baseInfo = JSON.parse(baseInfoString);
      setName(baseInfo?.data?.base?.name);
    } else {
      setName(baseInfo.name);
    }
  }, [baseInfo]);

  useEffect(() => {
    const baseInfoString = localStorage.getItem("baseDetails");
    if (baseInfoString) {
      const baseInfo = JSON.parse(baseInfoString);
      setSlug(baseInfo?.data?.base?.base_slug);
    } else {
      setSlug(baseInfo.base_slug);
    }
  }, [baseInfo]);

  useEffect(() => {
    const baseInfoString = localStorage.getItem("baseDetails");
    if (baseInfoString) {
      const baseInfo = JSON.parse(baseInfoString);
      setDescription(baseInfo?.data?.base?.description);
    } else {
      setDescription(baseInfo.description);
    }
  }, [baseInfo]);

  useEffect(() => {
    if (baseId) {
      dispatch(baseDetailsData(baseId));
    }
  }, [baseId, dispatch]);

  useEffect(() => {
    const baseInfoString = localStorage.getItem("baseDetails");
    if (baseInfoString) {
      const baseInfo = JSON.parse(baseInfoString);
      if (baseInfo?.data?.base?.logo) {
        setLogoLoading(true);
        const newLogoUrl = `${process.env.REACT_APP_API_BASE_URL}/${baseInfo?.data?.base?.logo}`;
        setLogoUrl(newLogoUrl);

        // Preload the image
        const img = new Image();
        img.onload = () => {
          setLogoLoading(false);
        };
        img.onerror = () => {
          setLogoLoading(false);
          setLogoUrl(""); // Reset to no logo if load fails
        };
        img.src = newLogoUrl;
      } else {
        setLogoUrl("");
        setLogoLoading(false);
      }
    } else {
      setLogoUrl("");
      setLogoLoading(false);
    }
  }, []);

  useEffect(() => {
    const baseInfoString = localStorage.getItem("baseDetails");
    if (baseInfoString) {
      const baseInfo = JSON.parse(baseInfoString);
      if (baseInfo?.data?.base?.cover_image) {
        setCoverLoading(true);
        const newCoverUrl = `${process.env.REACT_APP_API_BASE_URL}/${baseInfo?.data?.base?.cover_image}`;
        setLogoUrlCover(newCoverUrl);

        // Preload the image
        const img = new Image();
        img.onload = () => {
          setCoverLoading(false);
        };
        img.onerror = () => {
          setCoverLoading(false);
          setLogoUrlCover("");
        };
        img.src = newCoverUrl;
      } else {
        setLogoUrlCover("");
        setCoverLoading(false);
      }
    } else {
      setLogoUrlCover("");
      setCoverLoading(false);
    }
  }, []);

  useEffect(() => {
    const baseInfoString = localStorage.getItem("baseDetails");
    if (baseInfoString) {
      const baseInfo = JSON.parse(baseInfoString);
      setName(baseInfo?.data?.base?.name);
      localStorage.setItem("name", baseInfo.name || "");
    }
  }, []);

  useEffect(() => {
    const baseInfoString = localStorage.getItem("baseDetails");
    if (baseInfoString) {
      const baseInfo = JSON.parse(baseInfoString);
      setSlug(baseInfo?.data?.base?.base_slug);
    }
  }, []);

  useEffect(() => {
    const baseInfoString = localStorage.getItem("baseDetails");
    if (baseInfoString) {
      const baseInfo = JSON.parse(baseInfoString);
      setTimezone(baseInfo?.data?.base?.timezone);
    }
  }, []);

  useEffect(() => {
    const baseInfoString = localStorage.getItem("baseDetails");
    if (baseInfoString) {
      const baseInfo = JSON.parse(baseInfoString);
      setColor(baseInfo?.data?.base?.primary_color);
    }
  }, []);

  const _updateHandler = async () => {
    setBaseLoading(true);
    const payload: UpdateBasePayload = {
      name,
      timezone: timezone,
    };

    if (desEditable) {
      payload.base_slug = slug;
    }

    const userId = baseId;
    const resultAction = await dispatch(updateBase({ payload, userId }));
    setBaseLoading(false);
    if (updateBase.fulfilled.match(resultAction)) {
      localStorage.setItem("baseDetails", JSON.stringify(resultAction.payload));
      setData(resultAction.payload);
      setShowAlert(true);
      toast.success("Base updated successfully!");
      setDesEditable(false);
    } else {
      // Handle the error
      const errorMessage =
        (resultAction.payload as string) || "Failed to update base";
      setShowAlert(true);
      toast.error(errorMessage);
    }
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;
    setName(newName);
    localStorage.setItem("name", newName);
  };

  const handleSlugChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;
    setSlug(newName);
    setDesEditable(true);
  };

  const handleDescriptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newDescription = e.target.value;
    setDescription(newDescription);
    localStorage.setItem("base_description", newDescription);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const selectedFile = event.target.files[0];
      setFile(selectedFile);
      setCropSrc(URL.createObjectURL(selectedFile));
      setShowCropModal(true);
    }
  };

  const handleFileChangeCover = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (event.target.files && event.target.files[0]) {
      const selectedFile = event.target.files[0];
      setFileCover(selectedFile);
      setCropSrcCover(URL.createObjectURL(selectedFile));
      setShowCropModalCover(true);
    }
  };

  const onImageLoaded = (event: React.SyntheticEvent<HTMLImageElement>) => {
    imageRef.current = event.currentTarget;
    setCrop(
      centerCrop(
        makeAspectCrop(
          { unit: "px", width: 250, aspect: 1 },
          1,
          imageRef.current.width,
          imageRef.current.height,
        ),
      ),
    );
  };

  const onImageLoadedCover = (
    event: React.SyntheticEvent<HTMLImageElement>,
  ) => {
    imageRefCover.current = event.currentTarget;
    setCropCover(
      centerCrop(
        makeAspectCrop(
          { unit: "px", width: 1200, aspect: 7 / 2 },
          7 / 2,
          imageRefCover.current.width,
          imageRefCover.current.height,
        ),
      ),
    );
  };

  const getCroppedImageCover = (): Promise<File | null> => {
    if (
      !completedCropCover ||
      !imageRefCover.current ||
      !canvasRefCover.current ||
      !fileCover
    ) {
      return Promise.resolve(null);
    }

    const image = imageRefCover.current;
    const canvas = canvasRefCover.current;
    const crop = completedCropCover;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      return Promise.resolve(null);
    }

    canvas.width = 1200;
    canvas.height = 342;

    return new Promise((resolve) => {
      if (image.complete) {
        drawCanvas();
      } else {
        image.onload = drawCanvas;
      }

      function drawCanvas() {
        ctx.drawImage(
          image,
          crop.x * scaleX,
          crop.y * scaleY,
          crop.width * scaleX,
          crop.height * scaleY,
          0,
          0,
          1200,
          342,
        );

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              resolve(null);
              return;
            }
            const croppedFile = new File([blob], fileCover.name, {
              type: fileCover.type,
            });
            resolve(croppedFile);
          },
          fileCover.type,
          1,
        );
      }
    });
  };

  const getCroppedImage = (): Promise<File | null> => {
    if (!completedCrop || !imageRef.current || !canvasRef.current || !file) {
      return Promise.resolve(null);
    }

    const image = imageRef.current;
    const canvas = canvasRef.current;
    const crop = completedCrop;

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    const ctx = canvas.getContext("2d");

    if (!ctx) {
      return Promise.resolve(null);
    }

    canvas.width = 250; // Set canvas size to 150x150 for final output
    canvas.height = 250;

    return new Promise((resolve) => {
      if (image.complete) {
        drawCanvas();
      } else {
        image.onload = drawCanvas;
      }

      function drawCanvas() {
        ctx.drawImage(
          image,
          crop.x * scaleX,
          crop.y * scaleY,
          crop.width * scaleX,
          crop.height * scaleY,
          0,
          0,
          250,
          250,
        );

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              resolve(null);
              return;
            }
            const croppedFile = new File([blob], file.name, {
              type: file.type,
            });
            resolve(croppedFile);
          },
          file.type,
          1.0,
        );
      }
    });
  };

  const handleCropSave = async () => {
    if (!completedCrop) {
      toast.error("Please complete the crop before saving.");
      return;
    }

    setLogoLoading(true);
    try {
      const croppedFile = await getCroppedImage();
      if (!croppedFile) {
        throw new Error("Cropping failed or file is null.");
      }
      const result = await dispatch(
        uploadBaseLogo({
          payload: { image: croppedFile },
          userId: baseId,
        }),
      );

      if (uploadBaseLogo.fulfilled.match(result)) {
        toast.success("Upload successful!");
        const newLogoUrl = `${process.env.REACT_APP_API_BASE_URL}/${result.payload.data.base.logo}`;
        setLogoUrl(newLogoUrl);
        localStorage.setItem("baseDetails", JSON.stringify(result.payload));

        // Preload the new image
        const img = new Image();
        img.onload = () => {
          setLogoLoading(false);
        };
        img.onerror = () => {
          setLogoLoading(false);
          toast.error("Failed image to upload");
        };
        img.src = newLogoUrl;
      } else {
        throw new Error(result.payload || "Upload failed");
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error(error.message || "Upload failed. Please try again.");
      setLogoLoading(false);
    } finally {
      setShowCropModal(false);
    }
  };

  const handleCropSaveCover = async () => {
    if (!completedCropCover) {
      toast.error("Please complete the crop before saving.");
      return;
    }

    setCoverLoading(true);
    try {
      const croppedFile = await getCroppedImageCover();
      if (!croppedFile) {
        throw new Error("Cropping failed or file is null.");
      }

      const result = await dispatch(
        uploadBaseCover({
          payload: { image: croppedFile },
          userId: baseId,
        }),
      );

      if (uploadBaseCover.fulfilled.match(result)) {
        toast.success("Upload successful!");
        const newCoverUrl = `${process.env.REACT_APP_API_BASE_URL}/${result.payload?.data?.base?.cover_image}`;
        setLogoUrlCover(newCoverUrl);
        localStorage.setItem("baseDetails", JSON.stringify(result.payload));

        // Preload the new image
        const img = new Image();
        img.onload = () => {
          setCoverLoading(false);
        };
        img.onerror = () => {
          setCoverLoading(false);
          toast.error("Failed image to upload");
        };
        img.src = newCoverUrl;
      } else {
        throw new Error(result.payload || "Upload failed");
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error(error.message || "Upload failed. Please try again.");
      setCoverLoading(false);
    } finally {
      setShowCropModalCover(false);
    }
  };

  // if (error) {
  //   return <div>Error: {error}</div>;
  // }

  const handleEnableEdit = () => {
    setDesEditable(true);
  };

  const timezones = timezonesData.map((tz) => ({
    // value: tz.value,  // Make sure this exists
    label: tz.text,
    abbr: tz.abbr,
    utc: tz.utc,
  }));

  // Add this filtering logic
  const filteredTimezones = useMemo(() => {
    const query = searchQuery.trim().toLowerCase();
    if (!query) return timezones;

    return timezones.filter(
      (zone) =>
        zone.abbr.toLowerCase().includes(query) ||
        zone.label.toLowerCase().includes(query) ||
        zone.utc.some((utc) => utc.toLowerCase().includes(query)),
    );
  }, [timezones, searchQuery]);

  const handleTimeZoneChange = (newTimeZone: string) => {
    setTimezone(newTimeZone);
    // localStorage.setItem('timeZone', newTimeZone);
  };

  const handleNavigateToJob = () => {
    window.open(`https://jobs.teamer.app/${baseInfo?.base_slug}`, "_blank");
  };

  return (
    <>
      <main className="h-full flex">
        <div className=" w-full flex justify-center">
          <div className="w-full ">
            <div className="flex items-center justify-between gap-x-[6px]">
              <div className="flex flex-col gap-y-1 w-[90%]">
                <h2 className="text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]">
                  Organization Details
                </h2>
                <p className="text-sm leading-5 text-[#5c5c5e] font-medium">
                  This information will be publicly visible on your career page
                  and job postings. Please ensure all details are accurate and
                  up-to-date.
                </p>
              </div>
              <span
                data-title={"click to preview profile"}
                className="table-tooltip-list before:!bottom-[37px] before:!left-[7px] before:!text-[12px]"
              >
                <button
                  className=" rounded-md duration-200 font-[600] text-[0.8125rem] h-[32px] w-[32px] flex items-center justify-center border border-solid border-[#e7e7e8]"
                  style={{
                    transitionProperty:
                      "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
                  }}
                  onClick={handleNavigateToJob}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="currentColor"
                    aria-hidden="true"
                    data-slot="icon"
                    className="w-[1.1em] h-[1.1em] text-[#000]"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"
                    />
                  </svg>
                </button>
              </span>
            </div>
            <div className="bg-[#e0e0e0] w-full h-[1px] my-8"></div>
            {/* <div className="min-h-[172px] max-h-[172px] h-auto relative">
              <label className="h-full relative block">
                <input
                  className="opacity-0 focus:outline-none absolute top-[118px] left-[36px] h-[70px] w-[70px] flex justify-center items-center"
                  type="file"
                  onChange={handleFileChangeCover}
                  accept="image/*"
                />
                {coverLoading ? (
                  <div className="flex items-center justify-center bg-[#f5f5f5] rounded-2xl h-full w-full">
                    <div className="simple-spinner-loader">
                      <span className='!w-4 !h-4'></span>
                    </div>
                  </div>
                ) : logoUrlCover ? (
                  <img
                    src={logoUrlCover}
                    alt="Base Logo"
                    className="h-full max-h-[172px] object-cover w-full border border-[#e0e0e0] border-solid rounded-lg cursor-move"
                    onLoad={() => setCoverLoading(false)}
                  />
                ) : (
                  <div className="h-full w-full border-[5px] border-solid border-[#f5f5f5] rounded-2xl bg-gray-200 flex items-center justify-center">
                    <span className="text-gray-500 text-sm">No cover</span>
                  </div>
                )}

              </label>

              <label className="flex flex-inherit h-[70px] w-[70px] z-10 absolute top-[118px] left-[36px] cursor-move">
                <input className="opacity-0 focus:outline-none cursor-move" type="file" onChange={handleFileChange} accept="image/*" />
              </label>
              <div className="absolute top-[136px] left-[36px] h-[70px] w-[70px]">
                {logoLoading ? (
                  <div className="flex items-center justify-center bg-[#f5f5f5] rounded-2xl h-full w-full">
                    <div className="simple-spinner-loader">
                      <span className='!w-4 !h-4'></span>
                    </div>
                  </div>
                ) : logoUrl ? (
                  <img
                    src={logoUrl}
                    alt="Base Logo"
                    className="h-full w-full border-[5px] border-solid border-[#f5f5f5] rounded-2xl object-cover cursor-move"
                    onLoad={() => setLogoLoading(false)}
                  />
                ) : (
                  <div className="h-full w-full border-[5px] border-solid border-[#f5f5f5] rounded-2xl bg-gray-200 flex items-center justify-center">
                    <span className="text-gray-500 text-sm">No Logo</span>
                  </div>
                )}
              </div>
            </div> */}

            <div className="sm:col-span-4 mt-4 lg:mt-4">
              <label
                htmlFor="username"
                className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
              >
                Base name
              </label>
              <div className="mt-[6px] flex items-center">
                <div className="relative w-full">
                  {/* <Menu as='div' className='absolute left-2 top-1/2 -translate-y-1/2 z-10'>
                    <Menu.Button className="flex items-center justify-center h-5 w-5">
                      <div 
                      style={{background : color}}
                      className={`w-2 h-2 rounded-full`} />
                    </Menu.Button>
                    <Transition
                      as={Fragment}
                      enter='transition ease-out duration-100'
                      enterFrom='transform opacity-0 scale-95'
                      enterTo='transform opacity-100 scale-100'
                      leave='transition ease-in duration-75'
                      leaveFrom='transform opacity-100 scale-100'
                      leaveTo='transform opacity-0 scale-95'>
                
                      <Menu.Items className='absolute flex flex-wrap left-0 top-8 z-10 mt-2.5 w-64 p-2 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none'>
                
                        <div className="flex flex-wrap">
                          {colorList.map((value: any, index) => {
                            return (
                              <div
                                onClick={() => setColor(value.name)}
                                key={index}
                                style={{ background: value.name }}
                                className={`flex h-6 w-6 border rounded-full m-2 justify-center items-center`}
                              >
                                {(color === value.name) ? <CustomCheckIcon /> : null}
                              </div>
                            );
                          })}
                           <div
                            onClick={() => setShowColorPicker(!showColorPicker)}
                            className="cursor-pointer flex items-center"
                          >
                            <span className="text-sm border-gray-200 border-solid border rounded-md px-2 py-1">Custom</span>
                          </div>
                        </div>

                        {showColorPicker && (
                          <div className="mt-4">
                            <SketchPicker
                              color={typeof color === 'string' && color.startsWith('#') ? color : '#808080'} // Default to gray if color is not in hex format
                              onChangeComplete={(color) => setColor(color.hex)}
                            />
                          </div>
                        )}
                      </Menu.Items>
                    </Transition>

                  </Menu> */}
                  <input
                    id="name"
                    name="name"
                    type="name"
                    autoComplete="name"
                    onChange={handleNameChange}
                    placeholder="Enter Name"
                    value={name}
                    className="flex w-full items-center grow border px-4 py-2 pl-4 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500
                     outline-indigo-600 focus:outline focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc]
                      dark:hover:border-surface-200 border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"
                  />
                </div>
              </div>
            </div>

            <div className="flex justify-between items-center mt-7">
              <label
                htmlFor="slug"
                className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5"
              >
                Base Slug
              </label>
              <button onClick={handleEnableEdit}>Edit</button>
            </div>
            {!desEditable && (
              <div
                className="flex mt-[6px] grow rounded-lg border border-[#e5e7eb] bg-background px-4 py-[5px] text-sm leading-6
                shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500 outline-primary focus:outline
                 focus:outline-2 focus:-outline-offset-2 w-full text-surface-900 hover:border-surface-300
                dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600   
               "
              >
                {slug}
              </div>
            )}
            {desEditable && (
              <div className="mt-[6px]">
                <input
                  id="slug"
                  name="slug"
                  type="slug"
                  autoComplete="slug"
                  onChange={handleSlugChange}
                  placeholder="Enter slug"
                  value={slug}
                  className="flex w-full grow border px-4 py-[7px] pl-4 items-center text-sm shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                    focus:outline focus:outline-2 focus:-outline-offset-2 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                      border-[#d1d1db] dark:border-surface-100 focus:outline-indigo-600 rounded-[0.375rem]"
                />
              </div>
            )}

            {/* <div className='sm:col-span-4 mt-5'> */}
            <div className="flex justify-between items-center mt-7">
              {/* </div> */}
              <div className="sm:col-span-4 mt-0 w-full">
                <div className="flex flex-col justify-start items-start gap-y-[10px]">
                  <label
                    htmlFor="name"
                    className="wg-label inline-flex shrink-0 items-center gap-1 text-surface-900 wg-antialiased"
                  >
                    Timezone
                  </label>
                  <div className="w-full">
                    <Listbox value={timezone} onChange={setTimezone}>
                      {({ open }) => (
                        <div className="relative mt-[-5px] text-right flex justify-end">
                          <ListboxButton
                            className="w-[100%] inline-flex items-center justify-between whitespace-nowrap rounded-md 
                                                                                               text-sm font-normal transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2
                                                                                               focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 
                                                                                               border border-input bg-background shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] hover:bg-accent hover:text-accent-foreground h-[36px] px-3 py-2 hover:border-[#a9a9bc] dark:hover:border-surface-200
                                                                         border-[#d1d1db]"
                          >
                            <span className="block truncate line-clamp-1">
                              {timezones.find((tz) => tz.label === timezone) ? (
                                `${timezones.find((tz) => tz.label === timezone)?.abbr} - ${timezones.find((tz) => tz.label === timezone)?.label}`
                              ) : (
                                <span className="text-[#9ca3af] font-normal">
                                  Select Timezone
                                </span>
                              )}
                            </span>
                          </ListboxButton>

                          <ListboxOptions
                            className="  absolute top-[38px] z-10 mt-[2px] left-[0px] bg-white w-full max-w-full min-w-full rounded-lg border border-border
                                                                         bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out
                                                                           data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95
                                                                                                                            data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2
                                                                                                                             data-[side=top]:slide-in-from-bottom-2"
                          >
                            <div className="sticky top-0 z-10 bg-white p-1">
                              <div className="relative">
                                <input
                                  type="text"
                                  className="w-full px-3 py-1 border mt-1.5 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent text-sm"
                                  placeholder="Search timezone..."
                                  value={searchQuery}
                                  onChange={(e) =>
                                    setSearchQuery(e.target.value)
                                  }
                                  onClick={(e) => e.stopPropagation()}
                                  onKeyDown={(e) =>
                                    e.key === " " && e.stopPropagation()
                                  }
                                />
                                <div className="absolute top-[6px] bottom-0 right-0 flex items-center pr-2">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="text-gray-400"
                                  >
                                    <path
                                      stroke="none"
                                      d="M0 0h24v24H0z"
                                      fill="none"
                                    />
                                    <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                                    <path d="M21 21l-6 -6" />
                                  </svg>
                                </div>
                              </div>
                            </div>
                            <div className="overflow-auto max-h-[180px] mt-1">
                              {filteredTimezones.length > 0 ? (
                                filteredTimezones.map((tz) => (
                                  <ListboxOption
                                    key={tz.label}
                                    value={tz.label}
                                    className={({ active }) =>
                                      classNames(
                                        active
                                          ? "bg-gray-200 text-[#1d2025]"
                                          : "text-gray-900",
                                        "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                                      )
                                    }
                                  >
                                    {({ selected }) => (
                                      <>
                                        <span
                                          className={`block truncate ${selected ? "font-medium" : "font-normal"}`}
                                        >
                                          {tz.label}
                                        </span>
                                        {selected && (
                                          <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width={24}
                                              height={24}
                                              viewBox="0 0 24 24"
                                              fill="none"
                                              stroke="currentColor"
                                              strokeWidth={2}
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              className="w-4 h-4"
                                            >
                                              <path
                                                stroke="none"
                                                d="M0 0h24v24H0z"
                                                fill="none"
                                              />
                                              <path d="M5 12l5 5l10 -10" />
                                            </svg>
                                          </span>
                                        )}
                                      </>
                                    )}
                                  </ListboxOption>
                                ))
                              ) : (
                                <div className="px-2 py-1.5 text-sm text-gray-500 text-center">
                                  No timezone found
                                </div>
                              )}
                            </div>
                          </ListboxOptions>
                        </div>
                      )}
                    </Listbox>
                  </div>
                </div>
                {/* <label htmlFor='username' className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5'>
                                    Timezone
                                </label>
                                <div className='mt-[6px] w-full '>
                                    <SearchableDropdown
                                        previousValue={timeZone}
                                        onChangeValue={handleTimeZoneChange}
                                        data={timeZoneList}
                                    />
                                </div> */}
              </div>
            </div>
            <div className="mt-12 flex items-center justify-end">
              <button
                onClick={_updateHandler}
                type="submit"
                style={{
                  backgroundColor: color,
                  // Adjust hover and focus states dynamically
                  "--hover-color": `${color}80`, // 50% opacity for hover
                  "--focus-color": `${color}40`, // 25% opacity for focus
                }}
                //   className='group inline-flex shrink-0 w-full select-none items-center justify-center text-sm_small font-semibold leading-6 transition-colors
                //   duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 px-[8px]
                //    py-[6px] rounded-lg text-white outline-indigo-600
                //   disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600'                size="sm"
                //
                className="group inline-flex shrink-0 w-full select-none items-center justify-center text-sm_small font-semibold leading-6 transition-colors
              duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 px-[8px]
               py-[6px] rounded-md text-white outline-indigo-600
              disabled:opacity-50 hover:bg-[var(--hover-color)] focus-visible:bg-[var(--focus-color)]"
              >
                {baseLoading ? (
                  <div className="flex items-center  gap-[6px]">
                    Update
                    <div className="simple-spinner">
                      <span></span>
                    </div>
                  </div>
                ) : (
                  "Update"
                )}
              </button>
            </div>
          </div>
        </div>
      </main>

      <Transition.Root show={showCropModal} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => setShowCropModal(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-y-auto rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                  <div>
                    <ReactCrop
                      crop={crop}
                      onChange={(_, percentCrop) => setCrop(percentCrop)}
                      onComplete={(c) => {
                        setCompletedCrop(c);
                      }}
                      className="w-full"
                      aspect={1}
                    >
                      <img
                        src={cropSrc}
                        alt="Crop preview"
                        onLoad={onImageLoaded}
                        style={{ maxWidth: "100%", maxHeight: "100%" }}
                      />
                    </ReactCrop>
                    <canvas ref={canvasRef} className="hidden" />
                  </div>
                  <div className="flex justify-end mt-5">
                    <button
                      onClick={handleCropSave}
                      className="group inline-flex shrink-0 select-none justify-center 
    leading-6 transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 
    focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] rounded-md text-white outline-primary
    disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
                      disabled={logoLoading || !completedCrop}
                    >
                      {logoLoading ? (
                        <div className="flex items-center  gap-[6px]">
                          Save
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={showCropModalCover} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => setShowCropModalCover(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-y-auto rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-[800px] sm:p-6">
                  <div>
                    <ReactCrop
                      crop={cropCover}
                      onChange={(_, percentCrop) => setCropCover(percentCrop)}
                      onComplete={(c) => {
                        setCompletedCropCover(c);
                      }}
                      className="w-full"
                      aspect={7 / 2}
                    >
                      <img
                        src={cropSrcCover}
                        alt="Crop preview"
                        style={{ maxWidth: "100%", maxHeight: "100%" }}
                        onLoad={onImageLoadedCover}
                      />
                    </ReactCrop>
                    <canvas ref={canvasRefCover} className="hidden" />
                  </div>
                  <div className="flex justify-end mt-5">
                    <button
                      onClick={handleCropSaveCover}
                      className="group inline-flex shrink-0 select-none justify-center
                    leading-6 transition-colors duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 
                    focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] rounded-md text-white outline-primary
                    disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
                      disabled={coverLoading || !completedCropCover}
                    >
                      {coverLoading ? (
                        <div className="flex items-center  gap-[6px]">
                          Save
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
});

export default BaseManage;
